import segment from 'src/js/modules/analytics/segment';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';

const trackBlockLayoutDialogDisplayed = ({ blockId, blockVariationId, premiumBlocksAvailable }) => {
  if (!blockId) return;

  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.BLOCK_LAYOUT_DIALOG_DISPLAYED, {
    dialogId: dialogTypes.BLOCK_LAYOUT_DIALOG,
    blockId,
    blockVariationId,
    premiumBlocksAvailable,
  });
};

export default trackBlockLayoutDialogDisplayed;
